import { actions } from './promotion/actions'
import { mutations } from './promotion/mutations'
import { getters } from './promotion/getters'
import { state } from './promotion/state'
export default {
  namespaced: true,
  actions,
  state,
  mutations,
  getters
}
